import { render, staticRenderFns } from "./SocioCrear.vue?vue&type=template&id=6a1590d6&scoped=true"
import script from "./SocioCrear.vue?vue&type=script&lang=js"
export * from "./SocioCrear.vue?vue&type=script&lang=js"
import style0 from "./SocioCrear.vue?vue&type=style&index=0&id=6a1590d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1590d6",
  null
  
)

export default component.exports